<template>
    <page-container2 :title="formTitle" :useCard="false">
        <template v-slot:buttons>
            <permission-container>
                <el-button type="primary" size="mini" v-if="editable" v-on:click="save" :disabled="isSubmitting">保存</el-button>
            </permission-container>
        </template>
        <permission-container showTip :permissionId="permissionId">
            <el-form ref="aftersaleForm" :model="aftersale" v-loading="loading" status-icon :inline-message="true" :rules="rules" label-width="0px" size="mini">
                <el-card >
                    <div class="panel-info">
                        <div class="panel-info-name">
                            <span class="panel-info-label">基础信息</span>
                        </div>
                        <div class="panel-table">
                            <el-row class="panel-table-row">
                                <el-col :span="4"><span class="panel-table-col col-label required">客户：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        <el-form-item prop="customerId" :error="(!aftersale.customerId && errors['customerId'])? errors['customerId']: ''">
                                            <ClientSelectDialog
                                                v-model="aftersale.customerId"
                                                :clientName="aftersale.customerName"
                                                :tableList="clientList"
                                                title="请选择客户(正式客户)"
                                                @chooseClient="chooseClient"></ClientSelectDialog>
                                        </el-form-item>
                                        
                                    </div>
                                    <!-- <el-input v-model="aftersale.carrierCarNumber" size="mini" :readonly="true">
                                                <span slot="suffix" class="el-input__icon input-inner-suffix" v-if="!aftersale.id" @click="generateCode" >重新生成</span>
                                            </el-input> -->
                                </el-col>
                                <el-col :span="4"><span class="panel-table-col col-label">客户编号：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        <el-form-item prop="customerCode">
                                            <div>{{ aftersale.customerCode }}</div>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="4"><span class="panel-table-col col-label required">退货单号：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        <el-form-item prop="aftersaleCode" :error="(!aftersale.aftersaleCode && errors['aftersaleCode'])? errors['aftersaleCode']: ''">
                                            <el-input v-model="aftersale.aftersaleCode" size="mini" >
                                                <!-- <span slot="suffix" class="el-input__icon input-inner-suffix" v-if="!aftersale.id" @click="generateCode" >重新生成</span> -->
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row class="panel-table-row">
                                <el-col :span="4"><span class="panel-table-col col-label required">售后类型：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        <el-form-item prop="type" :error="(!aftersale.type && errors['type'])? errors['type']: ''">
                                            <el-select v-model="aftersale.type" placeholder="请选择" size="mini">
                                                <el-option
                                                    label="退货"
                                                    value="1">
                                                </el-option>
                                                <el-option
                                                    label="换货"
                                                    value="2">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="4"><span class="panel-table-col col-label required">退货日期：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        <el-form-item prop="returnDate" :error="(!aftersale.returnDate && errors['returnDate'])? errors['returnDate']: ''">
                                            <el-date-picker type="date" placeholder="选择日期" size="mini" v-model="aftersale.returnDate" value-format="timestamp" style="width: 100%;"></el-date-picker>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="4"><span class="panel-table-col col-label">关联订单：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        <el-form-item prop="orderId" :error="(!aftersale.orderId && errors['orderId'])? errors['orderId']: ''">
                                            <el-input v-model="aftersale.orderDeliveryNumber" size="mini" readonly>
                                                <span slot="suffix" class="el-input__icon input-inner-suffix" v-on:click="selectRelateOrder" >选择订单</span>
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                
                            </el-row>
                            <el-row class="panel-table-row">
                                <el-col :span="4"><span class="panel-table-col col-label">备注：</span></el-col>
                                <el-col :span="20">
                                    <div class="panel-table-col col-input">
                                        <el-input type="textarea" autosize v-model="aftersale.remark"></el-input>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        
                    </div>

                    <div class="panel-info">
                        <div class="panel-info-name">
                            <span class="panel-info-label">产品信息</span>
                        </div>
                        <div class="panel-table">
                            <el-row class="panel-table-row">
                                <el-col :span="6"><span class="panel-table-col col-header required">货物名称</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">规格</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">件数</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">数量</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">单位</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">单价</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">金额(RMB)</span></el-col>
                                <el-col :span="4"><span class="panel-table-col col-header">备注</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">操作</span></el-col>
                            </el-row>
                            <template v-for="(product, index) in productList">
                                <el-row class="panel-table-row">
                                    <el-col :span="6"><span class="panel-table-col col-input" v-if="product.productId">{{product.productName}}（{{product.productCode}}）</span></el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            <el-form-item prop="spec" :error="(!product.spec && errors['spec'])? errors['spec']: ''">
                                                <el-input v-model="product.spec" size="mini" type="text" ></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            <el-form-item prop="num" :error="(!product.num && errors['num'])? errors['num']: ''">
                                                <el-input v-model="product.num" size="mini" type="number"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            <el-form-item prop="unitNum" :error="(!product.unitNum && errors['unitNum'])? errors['unitNum']: ''">
                                                <el-input v-model="product.unitNum" size="mini" type="number" @change="(v)=>productUnitNumChange(v, index)"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            <el-form-item prop="unit" :error="(!product.unit && errors['unit'])? errors['unit']: ''">
                                                <el-select v-model="product.unit" placeholder="请选择" size="mini">
                                                    <el-option
                                                        label="Kg"
                                                        value="Kg">
                                                    </el-option>
                                                    <el-option
                                                        label="张"
                                                        value="张">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            <el-form-item prop="unitPrice" :error="(!product.unitPrice && errors['unitPrice'])? errors['unitPrice']: ''">
                                                <el-input v-model="product.unitPrice" size="mini" type="number" @change="(v)=>productUnitPriceChange(v, index)"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            <el-form-item prop="amount" :error="(!product.amount && errors['amount'])? errors['amount']: ''">
                                                <el-input v-model="product.amount" size="mini" type="number"></el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="panel-table-col col-input">
                                            <el-input v-model="product.remark" size="mini" type="text" ></el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: center;">
                                            <el-link type="warning" @click="handleReplaceProduct(index)" style="font-size: 12px;margin-right: 10px;">更改产品</el-link>
                                            <el-link type="danger" @click="deleteProduct(index)" style="font-size: 12px;">删除</el-link>
                                        </div>
                                    </el-col>
                                </el-row>
                            </template>
                        </div>
                        <div class="panel-info-tail">
                            <el-button type="primary" plain size="mini" v-on:click="handleShowProductListDialog">+ 添加产品</el-button>
                            <div class="total-price">合计：
                                <money-render :value="productTotalAmount"></money-render>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-form>
        </permission-container>
        <product-list-dialog ref="productListDialog" :onChoose="handleProductChoose"></product-list-dialog>
        <product-list-dialog ref="replaceProductDialog" :onChoose="handleReplaceProductChoose"></product-list-dialog>
        <dialog-table ref="relateOrderDialog" title="选择关联订单" :tableList="relateOrderList">
            <template v-slot:searchForm>
                <el-form-item>
                    <el-input v-model="relateOrderList.searchForm.deliveryNumber" placeholder="送货单号" clearable @keyup.enter.native="relateOrderList.load();"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-date-picker
                        style="width: 240px;"
                        v-model="relateOrderList.searchForm.deliverDateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="送货开始日期"
                        end-placeholder="送货结束日期"
                        @change="onDeliverDateChange"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="relateOrderList.searchForm.productName" placeholder="货物名称" clearable @keyup.enter.native="relateOrderList.load();"></el-input>
                </el-form-item>
            </template>
            <template v-slot:tableColumns>
                <el-table-column property="customer" label="客户">
                    <template slot-scope="scope">
                        <div>{{scope.row.customerName}}（{{scope.row.customerCode}}）</div>
                    </template>
                </el-table-column>
                <el-table-column property="deliveryNumber" label="送货单号" width="150">
                </el-table-column>
                <el-table-column property="deliverDate" label="送货日期" width="150">
                    <template slot-scope="scope">
                        <date-render :value="scope.row.deliverDate"/>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="150">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            type="primary"
                            @click="chooseOrder(scope.row, scope.$index)">选择</el-button>
                    </template>
                </el-table-column>
            </template>
        </dialog-table>
    </page-container2>
</template>

<script>
import List from "@/components/table/List";
import lodash from 'lodash';
export default {
    name: "AftersaleEdit",
    data()
    {
        return {
            aftersale: {
                id: null,
                aftersaleCode: '',
                customerId: null,
                customerCode: '',
                customerName: '',
                returnDate : null,
                type : null,
                remark: '',
                state: null,
                orderDeliveryNumber: null,
                orderId: null
            },
            productList:[],
            rules: {
            },
            loading: false,
            permissionId: "Erp.AfterSale.Add",
            formTitle: "新增售后单",
            clientList: new List({
                url: '/customer/selectList',
                searchForm: {
                    cooperation: '',
                },
            }),
            relateOrderList: new List({url: '/order/selectList', pageSize: 10, searchForm:{}}),
            errors: {},
            isSubmitting: false,
            replaceProductIdx: null
        };
    },
    mounted()
    {
        // console.log('user edit mounted.', this.$route.query);
        this.loading = true;
        return Fx.Promise.
        then(()=>
        {
            if(this.$route.query && this.$route.query.id)
            {
                this.formTitle = '修改售后单';
                this.permissionId = 'Erp.AfterSale.Edit';
                this.aftersale.id = this.$route.query.id;
                return this.loadAftersale();
            }
        }).
        then(()=>
        {
            // return this.generateCode();
        }).
        then(()=>
        {
            this.loading = false;
        });

    },
    methods: {
        loadAftersale()
        {
            return Fx.Http.post("/aftersale/get", {id: this.aftersale.id}).
            then((resp)=>
            {
                if(resp.isSuccess())
                {
                    this.aftersale = Fx.mergeDeep(this.aftersale, resp.getData());
                    this.productList = resp.getData('productList');
                    this.aftersale.type = ""+this.aftersale.type;
                    this.aftersale.returnDate = this.moment(this.aftersale.returnDate).unix()*1000;
                }
            });
        },
        chooseClient(client, index)
        {
            this.aftersale.customerId = client.id;
            this.aftersale.customerName = client.name;
            this.aftersale.customerCode = client.code;
            return this.generateDeleveryNumber();
        },
        generateDeleveryNumber()
        {
            console.log(this.aftersale.customerId);
            if(!this.aftersale.customerId) return Fx.Promise.resolve();
            return Fx.Http.post("/aftersale/generateAfterSaleCode", {"customerId": this.aftersale.customerId}).
            then((resp)=>
            {
                if(resp.isSuccess())
                {
                    this.aftersale.aftersaleCode = resp.getData("nextAfterSaleCode");
                }
                else
                {
                    this.showMessageError('生成单号失败:'+resp.getErrorMessage());
                }
            });
        },
        selectRelateOrder()
        {
            this.$refs.relateOrderDialog.show();
        },
        chooseOrder(order, index)
        {
            this.aftersale.orderId = order.id;
            this.aftersale.orderDeliveryNumber = order.deliveryNumber;
            this.$refs.relateOrderDialog.hide()
        },
        onDeliverDateChange(dateRange)
        {
            console.log("onDeliverDateChange >>>", dateRange);
            if(!dateRange)
            {
                dateRange = [null, null];
            }
            this.relateOrderList.searchForm.deliverDateBegin = dateRange[0];
            this.relateOrderList.searchForm.deliverDateEnd = dateRange[1];
        },
        valid()
        {
            this.errors = {};
            if(!this.aftersale.customerId)
            {
                this.errors['customerId'] = '请选择客户';
            }
            if(!this.aftersale.aftersaleCode)
            {
                this.errors['aftersaleCode'] = '请填写退货单号';
            }
            if(!this.aftersale.type)
            {
                this.errors['type'] = '请选择售后类型';
            }
            if(!this.aftersale.returnDate)
            {
                this.errors['returnDate'] = '请选择退货日期';
            }
            if(Object.keys(this.errors).length>0)
            {
                throw new Error('请检查表单必填项');
            }
            if(!this.productList.length) {
                throw new Error('请选择产品');
            }
            this.productList.map((product)=>
            {
                if(!product.spec)
                {
                    this.errors['spec'] = '请填写产品规格'
                }
                if(!product.num)
                {
                    this.errors['num'] = '请填写产品件数'
                }
                if(!product.unitNum)
                {
                    this.errors['unitNum'] = '请填写产品数量'
                }
                if(!product.unit)
                {
                    this.errors['unit'] = '请选择产品单位'
                }
                if(!product.unitPrice)
                {
                    this.errors['unitPrice'] = '请填写产品单价'
                }
                if(!product.amount)
                {
                    this.errors['amount'] = '请填写产品金额'
                }
            });
            if(Object.keys(this.errors).length>0)
            {
                throw new Error('请检查表单必填项');
            }
        },
        save(valid=true)
        {
            if (this.isSubmitting)
                return Promise.resolve();
            return Fx.Promise.then(()=>
            {
                if(valid)
                {
                    this.valid();
                }
            }).
            then(()=>
            {
                this.loading = true;
                this.isSubmitting = true;
                console.log('saveDraft',{
                    aftersale: this.aftersale,
                    productList: this.productList,
                    valid: valid
                });
                let saveData = {};
                saveData = Fx.mergeDeep(this.aftersale, saveData);
                saveData.productList = this.productList;
                return Fx.Http.post('/aftersale/save', saveData).
                then((resp)=>
                {
                    this.loading = false;
                    this.isSubmitting = false;
                    if(resp.isSuccess() && resp.getData("id"))
                    {
                        this.aftersale.id = resp.getData('id');
                        let productList = resp.getData("productList");
                        this.productList.map((product, i)=>
                        {
                            product.id = productList[i].id;
                        });
                        this.showMessageSuccess('保存成功');
                        // this.dispatchRouteBack();
                        return true;
                    }
                    else
                    {
                        this.showMessageError(resp.getErrorMessage());
                        return false;
                    }
                });
            }).
            catch(err=>
            {
                this.isSubmitting = false;
                this.loading = false;
                this.showMessageError(err.message);
                return false;
            });
        },
        deleteProduct(index)
        {
            this.showConfirm('确定要删除此商品吗？').
            then((result)=>
            {
                if(result)
                {
                    this.productList.splice(index, 1);
                }
            });
        },
        
        handleShowProductListDialog() {
            this.$refs.productListDialog&&this.$refs.productListDialog.show();
        },
        handleProductChoose(product) {
            // for(let pd of this.productList) {
            //     if(pd.productId == product.id) {
            //         this.showMessageError('该产品已添加，请确认');
            //         return;
            //     }
            // }
            // console.log("handleProductChoose", product);
            this.$refs.productListDialog.hide();
            return Fx.Promise.then(() =>
            {
                this.productList.push({
                    productId: product.id,
                    productName: product.name,
                    productCode: product.code,
                    customerOrderCode: '',
                    spec: '',
                    num: null,
                    unitNum: null,
                    unit: '',
                    unitPrice: null,
                    amount: null,
                    remark: '',
                    sortOrder: this.productList.length+1
                })
            });
        },
        handleReplaceProduct(index) {
            this.replaceProductIdx = index;
            this.$refs.replaceProductDialog&&this.$refs.replaceProductDialog.show();
        },
        handleReplaceProductChoose(product) {
            if(this.replaceProductIdx == null) {
                return;
            }
            this.productList[this.replaceProductIdx].productId = product.id;
            this.productList[this.replaceProductIdx].productName = product.name;
            this.productList[this.replaceProductIdx].productCode = product.code;
            this.replaceProductIdx = null;
            this.$refs.replaceProductDialog.hide();
        },
        
        productUnitNumChange(unitNum, index) {
            this.productPriceOrQuantityChange(index);
        },
        productUnitPriceChange(unitPrice, index) {
            this.productPriceOrQuantityChange(index);
        },
        productPriceOrQuantityChange(index) {
            let product = this.productList[index];
            if (product && product.unitNum && product.unitPrice)
            {
                product.amount = product.unitNum*product.unitPrice;
                product.unitPrice = parseFloat(product.unitPrice).toFixed(4);
                product.unitNum = parseFloat(product.unitNum).toFixed(4);
                product.amount = parseFloat(product.amount).toFixed(4);
            }
            else if (product)
            {
                product.amount = 0;
            }
            this.productList = this.productList.slice();
        },
    },
    computed:
    {
        productTotalAmount()
        {
            let amount = 0.00;
            this.productList.map(product=>amount+=(isNaN(product.amount)? 0: parseFloat(product.amount)));
            return amount;
        },
        editable()
        {
            return true;
        }
    },
}
</script>

<style>
.order-form .el-tabs__nav
{
    margin: 0px;
}
</style>

<style scoped>
.total-price
{
    font-size: 14px;
    font-weight: 700;
}

</style>



// WEBPACK FOOTER //
// src/modules/erp/pages/aftersale/Edit.vue